import { environment } from "src/environments/environment";

/**
 * Resolves the New Monaco home URL for the CRM sidebar menu.
 * FTrade tenants go to monacoUrlFtrade; every other tenant (or missing tenant) keeps monacoUrl.
 * @param tenantId - Current tenant id from the API (userSettings.tenantId).
 * @returns Absolute URL opened by the New Monaco menu item.
 */
export function resolveMonacoHomeUrl(tenantId?: string | null): string {
	const baseUrl =
		tenantId && tenantId === environment.ftradeTenantId
			? environment.monacoUrlFtrade
			: environment.monacoUrl;

	return `${baseUrl}home`;
}
